import { CommonModule } from '@angular/common';
import { Component, TemplateRef, computed, input, output, ChangeDetectionStrategy } from '@angular/core';

import { MdwButton } from '@spaces-ui/meadow/components/button';
import { MdwIcon } from '@spaces-ui/meadow/icons';
import { Close_Large } from '@spaces-ui/meadow/icons/svgs';

@Component({
  selector: 'mdw-dialog-header',
  imports: [CommonModule, MdwButton, MdwIcon],
  templateUrl: './header.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.scss',
})
export class MdwDialogHeader {
  public mainTitle = input<string>();
  public subtitle = input<string>();
  public showCloseButton = input<boolean>(false);
  public icon = input<string | TemplateRef<HTMLElement>>();
  public rightContent = input<TemplateRef<HTMLElement>>();
  public closed = output<void>();

  public iconIsTemplate = computed(() => {
    const icon = this.icon();
    return icon instanceof TemplateRef;
  });

  public iconTemplate = computed(() => {
    const icon = this.icon();
    return icon instanceof TemplateRef ? icon : undefined;
  });

  public iconSvg = computed(() => {
    const icon = this.icon();
    return icon instanceof TemplateRef ? undefined : icon;
  });

  public icons = { Close_Large };
}
